import * as React from "react";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import DropdownIcon from "./icon/index";
import { DropdownProps } from "./types";

import "./styles.scss";

export default function Dropdown(props: DropdownProps): React.JSX.Element {
  const {
    disabled,
    error,
    errorText,
    label,
    menuItems,
    onSelect,
    onBlur,
    selectedItemValue,
    descriptionText,
    dropdownInputProps,
    className,
  } = props;

  const classNameBase = "scd-dropdown";

  const classNameDropdown =
    `${classNameBase}-wrapper` +
    `${error ? ` ${classNameBase}-wrapper-error` : ""}` +
    `${disabled ? ` ${classNameBase}-wrapper-disabled` : ""}`;

  const classNameInputLabel =
    `${classNameBase}-label` +
    `${disabled ? ` ${classNameBase}-label-disabled` : ""}`;

  const classNameSelect =
    `${classNameBase}-select-wrapper` +
    `${disabled ? ` ${classNameBase}-select-wrapper-disabled` : ""}`;

  return (
    <div className={`${classNameBase} ${className}`}>
      <div className={`${classNameBase}-container`}>
        <FormControl
          className={classNameDropdown}
          error={error}
          disabled={disabled}
        >
          <InputLabel
            classes={{
              shrink: `${classNameBase}-shrinked-label`,
              focused: `${classNameBase}-shrinked-label-focused`,
            }}
            className={classNameInputLabel}
          >
            {label}
          </InputLabel>
          <Select
            displayEmpty
            variant="standard"
            className={`${classNameBase}-input`}
            classes={{
              standard: classNameSelect,
              select: `${classNameBase}-select`,
              outlined: `${classNameBase}-select-outlined`,
              disabled: `${classNameBase}-select-disabled`,
            }}
            inputProps={dropdownInputProps}
            IconComponent={DropdownIcon}
            MenuProps={{
              anchorPosition: { top: 0, left: 0 },
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
              },
              transformOrigin: {
                vertical: "top",
                horizontal: "left",
              },
              classes: {
                paper: `${classNameBase}-menu-paper`,
                list: `${classNameBase}-menu-list`,
              },
            }}
            onChange={onSelect}
            onBlur={onBlur}
            value={selectedItemValue || ""}
          >
            {menuItems.map((mi, index) => (
              <MenuItem
                className={`${classNameBase}-select-item`}
                classes={{
                  selected: `${classNameBase}-select-item-selected`,
                }}
                key={index}
                value={mi.value}
                disabled={mi.disabled || false}
              >
                {mi.children}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <>
        {errorText ? (
          <FormHelperText className={`${classNameBase}-error`} error={error}>
            {errorText}
          </FormHelperText>
        ) : null}
      </>
      <>
        {descriptionText && !error ? (
          <FormHelperText className={`${classNameBase}-description`}>
            {descriptionText}
          </FormHelperText>
        ) : null}
      </>
    </div>
  );
}
